import React from "react";
import Card from "react-bootstrap/Card";

import UrlEntries from "./UrlEntries.jsx";

const Dashboard = () => {
  return (
    <Card>
      <Card.Header className="card-header-borderless" as="h3">
        URL module
      </Card.Header>
      <Card.Body>
        <UrlEntries />
      </Card.Body>
    </Card>
  );
};

export default Dashboard;
